<template>
  <div class="animated fadeIn">
    <transition name="fade">
      <b-card id="main-card" no-body>
        <b-card-header>
          <i class="fa fa-list mr-2"></i>
          <strong>Gestion des produits</strong>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col id="column-1" sm="3">
              <h4>Liste des produits devant être qualifiés</h4>
              <draggable
                v-model="produitsToConfigure"
                class="list-group"
                tag="ul"
                v-bind="dragOptions"
                @start="isDragging = true"
                @end="changeList"
                :disabled="!canManageFamille()">
                <transition-group type="transition" name="flip-list">
                  <li
                    class="list-group-item"
                    v-for="produit in produitsToConfigure"
                    :key="produit.id"
                    @dragstart="manageProduit(produit)"
                    @drop="changeListProduit(produit.famille_id)"
                  >
                    {{ produit.code_produit }} {{ produit.code_produit }} <br> <i class="text-primary">{{ produit.code_produit }}</i>
                  </li>
                </transition-group>
              </draggable>
            </b-col>
            <b-col id="column-2" sm="9">
              <b-row>
                <b-card v-for="(item, key) in items" class="col-sm-4 card-equipe" sm="4" no-body :key="key">
                  <b-card-header>
                    Famille : {{item.libelle}}
                  </b-card-header>
                  <b-card-body>
                    <div class="drag-box drag-haut"
                      @drop="onDrop($event, key)" 
                      @dragover.prevent 
                      @dragenter.prevent
                    >
                      <div class="zone-title">Gamme : {{ item.gamme.libelle }}</div>
                      <draggable
                        :ref="'zone-responsable-'+key"
                        v-model="item.produits"
                        class="list-group zone"
                        tag="ul"
                        v-bind="dragOptions"
                        :sort="true"
                        @start="isDragging = false"
                        @end="changeList"
                      >
                        <transition-group type="transition" name="flip-list">
                          <li
                            class="list-group-item"
                            v-for="produit in item.produits"
                            :key="produit.id"
                            @dragstart="startDrag($event, produit)"
                            @drop="changeListProduit(produit.famille_id)"
                          >
                            {{ produit.code_produit }} {{ produit.code_produit }} <br><span class="smaller text-primary">{{ produit.code_produit }}</span>
                            
                          </li>
                        </transition-group>
                      </draggable>
                    </div>
                  </b-card-body>
                </b-card>
              </b-row>
            </b-col>
          </b-row>
        </b-card-body>
        <div slot="footer">
          <b-button type="button" @click="returnBack" size="md" variant="secondary">
            <i class="fa fa-arrow-left"></i> Liste des produits
          </b-button>
        </div>
      </b-card>
    </transition>
    <b-modal centered no-close-on-esc no-close-on-backdrop hide-header-close id="modal-qualification-produit" ref="modal-qualification-produit" :title="'Qualification du produit : '+code_produit">
      <b-form-group id="fieldset-description" label="Description du produit *" label-for="description">
        <b-form-input id="description" v-model="description" :class="{hasError: errors.description !== ''}" trim placeholder="Ex. : Accord FR"></b-form-input>
        <span class='field-error'>{{ errors.description }}</span>
      </b-form-group>
      <b-form-group id="fieldset-precision" label="Précision sur le produit" label-for="precision">
        <b-form-input id="precision" v-model="precision" :class="{hasError: errors.precision !== ''}" trim placeholder="Ex. : Option Prémensu."></b-form-input>
        <span class='field-error'>{{ errors.precision }}</span>
      </b-form-group>
      <b-form-group id="fieldset-type" label="Type de produit *" label-for="type">
        <b-form-select v-model="type" :options="allTypeOption"  :class="{hasError: errors.type !== ''}">
          <template v-slot:first>
            <b-form-select-option value="">-- Sélectionnez un type --</b-form-select-option>
          </template>
        </b-form-select>
        <span class='field-error'>{{ errors.type }}</span>
      </b-form-group>
      <b-form-group id="fieldset-onSale" label="Le produit est-il toujours disponible à la vente *" label-for="radio-group-onSale">
        <b-form-radio-group id="radio-group-onSale" v-model="onSale" name="radio-sub-component">
          <b-form-radio value="true">Oui</b-form-radio>
          <b-form-radio value="false">Non</b-form-radio>
        </b-form-radio-group>
        <span class='field-error'>{{ errors.onSale }}</span>
      </b-form-group>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <b-button type="button" @click.prevent="clearFormProduit()" size="md" variant="secondary" class="mr-2 mt-2">Annuler</b-button>
          <button type="button" @click="saveProduit()" class="btn btn-primary"><i class="fa fa-save"></i> Enregistrer</button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth'
import { hasRule, espaceGestionRules as rules } from '@/utils/rulesHelper'
import draggable from 'vuedraggable'
import Chrome from 'vue-color'

export default {
  components: {
    draggable,
    'chrome-picker': Chrome
  },
  data() {
    return {
      columns: ['gamme', 'libelle', 'code_produit'],
      items: [],
      options: {
        headings: {
          gamme: 'Gamme',
          libelle: 'Famille',
          code_produit: 'Codes produits'
        },
        columnsClasses: {
          action: 'action-xs'
        },
        sortable: ['libelle'],
        filterable: ['code_produit'],
        // initFilters: {},
        perPage: 10,
        perPageValues: [10, 20, 25],
        texts: { filterPlaceholder: 'Code produit' },
        // orderBy: { column: 'created_at', ascending: false },
        customFilters: [{
          name: 'code_produit',
          callback: function (row, query) {
            return 'APAJHTH';
          }
        }]
      },
      allFamilleProduit: [],
      allFamilleGammeGrouped: [],
      modify: false,
      familleId: '',
      libelle: '',
      produits: [],
      code_produit: '',
      description: '',
      precision: '',
      type: '',
      onSale: '',
      produitId: '',
      familleCodeProduitId: '',
      gamme: '',
      allType: [],
      allTypeOption: [],
      allFamilleProduitOption: [],
      produitsToConfigure: [],
      errors: {
        libelle: '',
        description: '',
        precision: '',
        familleCodeProduitId: '',
        type: '',
        onSale: '',
      },
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    }
  },
  mounted() {
    this.changeCardHeight()
    window.onresize = this.changeCardHeight
    this.getProduitsToConfigure()
    this.getTypeProduit()
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json';
    this.$axios.defaults.headers.common['Provider'] = getProvider();
    this.getFamilleProduit()
  },
  methods: {
    startDrag: (evt, item) => {
      evt.dataTransfer.dropEffect = 'move'
      evt.dataTransfer.effectAllowed = 'move'
      evt.dataTransfer.setData('itemID', item.id)
    },
    onDrop (evt, list) {
      const itemID = evt.dataTransfer.getData('itemID')
      const item = this.items.find(item => item.id == itemID)
      item.id = list
    },
    changeCardHeight() {
      let mainCard = document.getElementById('main-card')
      let column1 = document.getElementById('column-1')
      let column2 = document.getElementById('column-2')
      mainCard.style.height = (window.innerHeight - 150) + 'px'
      column1.style.height = (window.innerHeight - 250) + 'px'
      column2.style.height = (window.innerHeight - 250) + 'px'
    },
    closeModal(refModal) {
      this.$refs[refModal].hide()
    },
    add() {
      this.$router.push({path: '/espace-gestion/famille-produit/add'})
    },
    returnBack() {
      this.$router.push({path: '/espace-gestion/famille-produit/list'})
    },
    getFamilleProduit() {
      let self = this
      this.$store.commit('IS_LOADING', true)
      this.$axios
        .get('/espaceGestion/famille-produit/all')
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          this.items = response.data.familles
          this.allFamilleProduit = response.data.familles
          this.allFamilleProduitOption = _.sortBy(response.data.familles, ['libelle']).map( famille => {return {value: famille.id, text: famille.libelle}})
          this.allFamilleGammeGrouped = _.sortBy(_.groupBy(this.allFamilleProduit, 'gamme_id'), [function(obj) { return obj[0].gamme.libelle; }])
          // console.log(this.allFamilleGammeGrouped)
        })
        .catch(function(error) {
          console.log(error)
          self.$store.commit('IS_LOADING', false)
          self.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Une erreur est survenue, si le problème persiste merci de contacter faire un ticket au support DOSI',
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    getProduitsToConfigure() {
      let self = this
      this.$store.commit('IS_LOADING', true)
      this.$axios
        .get('/espaceGestion/famille-produit/get-produit-to-configure')
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          this.produitsToConfigure = response.data.produits
        })
        .catch(function(error) {
          console.log(error)
          self.$store.commit('IS_LOADING', false)
          self.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Une erreur est survenue, si le problème persiste merci de contacter faire un ticket au support DOSI',
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    getTypeProduit() {
      let self = this
      this.$store.commit('IS_LOADING', true)
      this.$axios
        .get('/espaceGestion/famille-produit/get-type-produit')
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          this.allType = response.data.types
          this.allTypeOption = response.data.types.map( type => {return {value: type.id, text: type.libelle_court}})
        })
        .catch(function(error) {
          console.log(error)
          self.$store.commit('IS_LOADING', false)
          self.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Une erreur est survenue, si le problème persiste merci de contacter faire un ticket au support DOSI',
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    canManageFamille() {
      return hasRule(rules.CAN_MANAGE_PRODUIT)
    },
    edit(famille) {
      // console.log(famille)
      this.modify = true
      this.familleId = famille.id
      this.libelle = famille.libelle
      this.produits = famille.produits
    },
    validateFormFamille() {
      let valid = true

      if (this.libelle === '') {
        this.errors.libelle = 'Le libelle est obligatoire'
        valid = false;
      }

      return valid
    },
    validateFormProduit() {
      let valid = true

      if (this.description === '') {
        this.errors.description = 'La description est obligatoire'
        valid = false;
      }

      if (this.familleCodeProduitId === '') {
        this.errors.familleCodeProduitId = 'La famille de produit est obligatoire'
        valid = false;
      }

      if (this.type === '') {
        this.errors.type = 'La type de produit est obligatoire'
        valid = false;
      }

      if (this.onSale === '') {
        this.errors.onSale = 'La disponibilité du produit à la vente est obligatoire'
        valid = false;
      }

      return valid
    },
    clearFormProduit() {
      this.produitId = ''
      this.description = ''
      this.precision = ''
      this.type = ''
      this.onSale = ''
      this.familleCodeProduitId = ''
      this.errors.description = ''
      this.errors.type = ''
      this.errors.familleCodeProduitId = ''
      this.errors.onSale = ''
      this.getFamilleProduit()
      this.getProduitsToConfigure()
      this.closeModal('modal-qualification-produit')
    },
    manageProduit(produit) {
      this.produitId = produit.id
      this.description = produit.description
      this.precision = produit.precision
      this.type = produit.type_id
      this.familleCodeProduitId = produit.famille_id
      this.onSale = produit.vente
      this.code_produit = produit.code_produit
    },
    changeList() {
      // this.$refs['modal-qualification-produit'].show();
    },
    changeListProduit(familleId) {
      this.$refs['modal-qualification-produit'].show();
      this.familleCodeProduitId = familleId
    },
    saveProduit() {
      if (this.validateFormProduit()) {
        let self = this;
        let dataPost = {
          'description': this.description,
          'precision': this.precision,
          'type': this.type,
          'familleId': this.familleCodeProduitId,
          'onSale': this.onSale,
        }
        console.log(dataPost)
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .post('/espaceGestion/famille-produit/attach/'+this.produitId, dataPost)
          .then(response => {
            this.$store.commit('IS_LOADING', false)
            self.$swal({
              position: 'top',
              type: 'success',
              title: 'Modification avec succès',
              text: 'La modification a bien été apportée',
              showConfirmButton: false,
              timer: 3000
            })
            this.clearFormProduit()
            this.$root.$emit('bv::toggle::collapse', 'collapse-produit')
            this.getFamilleProduit()
            this.getProduitsToConfigure()
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue lors de la modification du produit, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            })
          })
      }
    },
    formatDate(textDate) {
      let date = textDate !== null? new Date(textDate).toLocaleDateString('fr-FR') : '-'
      return date
    },
    formatBytes(bytes, precision = 2) {
      let units = ['o', 'Ko', 'Mo', 'Go', 'To']

	    let varBytes = Math.max(bytes, 0);
	    let pow = Math.floor((bytes ? Math.log(bytes) : 0) / Math.log(1024))
	    pow = Math.min(pow, units.length - 1)

	    varBytes /= Math.pow(1024, pow)

	    return Math.round(varBytes, precision) + ' ' + units[pow]
	  },
  }
}
</script>
<style type="text/css">
  .with-index .list-group-item {
    padding: 0;
  }
  .with-index .list-group-item .index, .with-index .list-group-item .body {
    display: inline-block;
    padding: 0.5rem 1rem;
  }
  .with-index .list-group-item .index {
    background-color: #EFEFEF;
    border-right: 1px solid #EAEAEA;
    width: 166px;
  }
  .lh {
    line-height: 37px;
  }
  .list-produit {
    line-height: 30px;
  }
  .list-produit .badge {
    line-height: 1rem;
  }
  table.famille_produit tr td, table.famille_produit tr th {
    border: 1px solid #dbdbdb;
    padding: 0.5rem;
  }
  table.famille_produit tr td:first-child
   {
    border-radius: 5px 0 0 5px;
  }
  table.famille_produit tr td:last-child 
   {
    border-radius: 0 5px 5px 0;
  }
  table.famille_produit tr th {
    background-color: #659ac8;
  }
  table.famille_produit tr td.td-gamme {
    background-color: #e4f2ff;
  }
  table.famille_produit tr th.th-famille {
    min-width: 300px;
  }
  #main-card {
    height: 700px;
  }

  #column-1 {
    height: 600px;
    overflow: auto;
  }

  #column-2 {
    height: 600px;
    overflow: auto;
  }

  .zone {
    min-height: 3em;
  }

  .close {
    float: right;
    font-weight: normal;
    font-size: 0.8em;
  }

  .zone-title {
    width: 100%;
    font-size: 0.9em;
    font-weight: bold;
    text-align: center;
    background-color: #EFEFEF;
  }

  .full:hover {
    cursor: not-allowed;
  }

  .card-equipe .card-body {
    border: 1px solid #BFBFBF;
  }

  .card {
    border: none;
  }

  .drop-zone {
    background-color: #eee;
    margin-bottom: 10px;
    padding: 10px;
  }
  .drag-el {
      background-color: #fff;
      margin-bottom: 10px;
      padding: 5px;
  }

</style>